import { fetchPointsBurnLuxeLogic } from './fetchPointsBurnLuxeLogic';

export const logic = [fetchPointsBurnLuxeLogic];
